import { useState } from 'react'
import classnames from 'classnames'
import Button from '@components/Button'
import CancelSubscriptionModal from 'dashboard-subscriptions/components/CancelSubscriptionModal'

import styles from './styles.module.scss'

const SubscriptionModalFooter = ({
    closeModal,
    isLoading,
    mainAction,
    mainActionLabel,
    disableMainAction = false,
    error,
    disableCancelSubscription,
}) => {
    const [showCancelModal, setShowCancelModal] = useState(false)
    return (
        <div className={styles.subscriptionModalFooter}>
            {showCancelModal && <CancelSubscriptionModal closeModal={() => setShowCancelModal(false)} />}
            {error && <span className={classnames('mt-3', 'd-block', styles.error)}>{error}</span>}
            <div className="d-flex justify-content-between align-items-center ">
                <Button
                    btnStyle="link"
                    disabled={disableCancelSubscription}
                    className={styles.lineDescription}
                    onClick={() => setShowCancelModal(true)}>
                    <T>dashboard.subscriptions.cancel</T>
                </Button>

                <div className="d-flex justify-content-center mt-3 mt-sm-0">
                    <Button btnStyle="outline" onClick={closeModal}>
                        <T>dashboard.subscriptions.modal.close</T>
                    </Button>
                    {mainActionLabel && (
                        <Button
                            disabled={disableMainAction || isLoading}
                            isLoading={isLoading}
                            btnStyle="primary"
                            type="submit"
                            onClick={mainAction}>
                            {mainActionLabel}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SubscriptionModalFooter
